import { render, staticRenderFns } from "./IconRewardSortBy.vue?vue&type=template&id=6a51740d"
import script from "./IconRewardSortBy.vue?vue&type=script&lang=js"
export * from "./IconRewardSortBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports